export default __webpack_public_path__ + "static/media/Group 3199@2x.aa918aba.png";